import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Nav, Navbar, Container, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faBook, faInfoCircle, faList, faAppleAlt, faPhone, faEnvelope, faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
import './NavMenu.css';

export default function NavMenu() {
  const location = useLocation();
  return <Container fluid id="navbar-container">
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" collapseOnSelect>
      <Navbar.Brand as={Link} to="/">
        Lake Forest Ward
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse>
        <Nav className="flex-column" activeKey={location.pathname.slice(1) || 'home'} navbar>
          <Nav.Link as={Link} to="/" eventKey="home"><FontAwesomeIcon icon={faHouse}/> Home</Nav.Link>
          <Nav.Link as={Link} to="/program" eventKey="program"><FontAwesomeIcon icon={faBook}/> Program</Nav.Link>
          <Nav.Link as={Link} to="/announcements" eventKey="announcements"><FontAwesomeIcon icon={faList}/> Announcements</Nav.Link>
          <Nav.Link as={Link} to="/communication" eventKey="communication"><FontAwesomeIcon icon={faPhone}/> Ward Communication</Nav.Link>
          <NavDropdown title={<><FontAwesomeIcon icon={faPeopleGroup}/> Auxiliaries</>}>
            <NavDropdown.Item as={Link} to="/elders" eventKey="elders">Elder's Quorum</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/primary" eventKey="primary">Primary</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/rs" eventKey="rs">Relief Society</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/sundayschool" eventKey="sundayschool">Sunday School</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/ym" eventKey="ym">Young Men</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/yw" eventKey="yw">Young Women</NavDropdown.Item>
          </NavDropdown>
          {/*<Nav.Link as={Link} to="/building-cleaning"><FontAwesomeIcon icon={faHouse} /> Building Cleaning Schedule</Nav.Link>*/}
          <Nav.Link as={Link} to="/emergency-prep" eventKey="emergency-prep"><FontAwesomeIcon icon={faList} /> Emergency Preparedness</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </Container>
}
